<template>
  <div id="sceances">
    <span v-if="item['h10']">10h<span v-if="item['h14'] || item['h18'] || item['h20'] || item['matin'] || item['apresmidi']">,</span>&nbsp;</span>
    <span v-if="item['h14']">14h<span v-if="item['h18'] || item['h20'] || item['matin'] || item['apresmidi']">,</span>&nbsp;</span>
    <span v-if="item['h18']">18h<span v-if="item['h20'] || item['matin'] || item['apresmidi']">,</span>&nbsp;</span>
    <span v-if="item['h20']">20h<span v-if="item['matin'] || item['apresmidi']">,</span>&nbsp;</span>
    <span v-if="item['matin']">Matin<span v-if="item['apresmidi']">,</span>&nbsp;</span>
    <span v-if="item['apresmidi']">Après-midi&nbsp;</span>
  </div>
</template>

<script>
export default {
    props: {
        item: Object
    }
}
</script>